import { chain, map, pick, get } from "lodash"

export function getFactorCalculationResultsByDate(factors, path) {
  return chain(factors)
    .reduce((factorPerformance, factor) => ([
      ...factorPerformance,
      ...map(get(factor, path), calculatedResults => ({ ...calculatedResults, ...pick(factor, ["id", "name", "category"]) })),
    ]), [])
    .groupBy("date")
    .value()
}
